import React, { useEffect, useState, useContext, useRef } from 'react';
import SvgInverter from './SvgInverter';

function SvgInverters({x, y, width, height, invColumnsCount, invRowsCount, slaveAs, slaveBs, slaveCs, slaveGs, onGotoIvnerterList }) {
    let ggs = [];
    if (slaveGs.length > 0) {
        let gs = [];
        let nCellsPrior = 0;
        let nCells = 0; // cells per current row 
        let nRows = 1; // rows
        for (let i = 0; i < slaveGs.length; i++) {
            nCells++;
            let x = 0;
            let y = 0;
            if (invColumnsCount+invRowsCount > 2) {
                x = (110 + 15) * (nCells - 1);
                y = (70 + 20) * (nRows - 1);
            } else {
                x = 0;
                y = 0;
            }
            if (nCells > 1) {
                gs.push(<path d={`M ${x-15} ${y+70/2} l 15 0`} stroke="#1d80b5" strokeWidth="2" fill="none" />);
            }
            gs.push(<SvgInverter x={x} y={y} width={110} height={70} Data={slaveGs[i]} />);
            if (nCells == invColumnsCount || i == slaveGs.length - 1) {
                if (nRows > 1) {
                    let x = nCellsPrior*(110+15) - 15 - 110/2;
                    let y = (nRows-1) * (70 + 20) - 20 -2;
                    ggs.push(<path d={`M ${x} ${y} l 0 12 L ${110/2} ${y + 12} l 0 12`} stroke="#1d80b5" strokeWidth="2" fill="none" />);
                }
                ggs.push(<svg>{gs.map((item) => { return item; })}</svg>);
                gs = [];
                nCellsPrior = nCells;
                nCells = 0;
                nRows++;
            }
        }
    } else {
        let nRows = 1; // rows
        [slaveAs, slaveBs, slaveCs].forEach((ss, index) => {
            let phase = ['A', 'B', 'C'][index];
            let gs = [];
            let nCellsPrior = 0;
            let nCells = 0; // cells per current row 
            for (let i = 0; i < ss.length; i++) {
                nCells++;
                let x = 0;
                let y = 0;
                if (invColumnsCount+invRowsCount > 2) {
                    x = (110 + 15) * (nCells - 1);
                    y = (70 + 20) * (nRows - 1);
                } else {
                    x = 0;
                    y = 0;
                }
                if (nCells > 1) {
                    // let x = (nCells-1)*(110+15) - 15;
                    gs.push(<path d={`M ${x-15} ${y+70/2} l 15 0`} stroke="#1d80b5" strokeWidth="2" fill="none" />);
                }
                gs.push(<SvgInverter x={x} y={y} width={110} height={70} phase={phase} Data={ss[i]} />);
                if (nCells == invColumnsCount || i == ss.length - 1) {
                    if (nCellsPrior > 0) {
                        let x = nCellsPrior*(110+15) - 15 - 110/2;
                        let y = (nRows-1) * (70 + 20) - 20 -2;
                        ggs.push(<path d={`M ${x} ${y} l 0 12 L ${110/2} ${y + 12} l 0 12`} stroke="#1d80b5" strokeWidth="2" fill="none" />);
                    }
                    ggs.push(<svg>{gs.map((item) => { return item; })}</svg>);
                    gs = [];
                    if (i == ss.length - 1) {
                        nCellsPrior = 0
                    } else {
                        nCellsPrior = nCells;
                    }
                    nCells = 0;
                    nRows++;
                }
            }
        });
    }

    let w = 0;
    let h = 0;
    if (invColumnsCount+invRowsCount > 2) {
        w = invColumnsCount * (110 + 15) - 15 + 20;
        h = invRowsCount * (70 + 20) - 20 + 20;
    } else {
        w = 110;
        h = 70;
    }

    return (<svg x={x} y={y} width={width} height={height} cursor={"pointer"} xmlns="http://www.w3.org/2000/svg" viewBox={"0 0 " + (w) + " " + (h)}
        onClick={onGotoIvnerterList}
    >
        <rect x={0} y={0} width={w} height={h} fill="#fff"></rect>
        {(invColumnsCount+invRowsCount>2)&&<rect x="2" y="2.5" width={(invColumnsCount||1) * (110 + 15) - 15 + 15.5} height={(invRowsCount||1) * (70 + 20) - 20 + 15.5} rx="3.63" fill='none' stroke="#1d80b5" strokeWidth="2" />}
        <svg x={invColumnsCount+invRowsCount > 2 ? 10:0} y={invColumnsCount+invRowsCount > 2 ? 10:0}>
            {ggs.map((item) => { return item; })}
        </svg>
    </svg>);
}

export default SvgInverters;

